import * as React from 'react'
import { headingVariants, type HeadingVariantProps } from './Heading.variants'
import { cn } from '../../utils/cn'

export type HeadingProps = HeadingVariantProps &
  React.HTMLAttributes<HTMLHeadingElement | HTMLSpanElement> & {
    as?: React.ElementType
    children: React.ReactNode
  }

const tagMap = {
  display: 'span',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  hero: 'h1',
  page: 'h1',
  section: 'h2',
  sectionCompact: 'h2',
  panel: 'h2',
  cardXl: 'h3',
  cardLg: 'h3',
  card: 'h3',
  cardSm: 'h3',
  eyebrow: 'span',
} as const

export default function Heading({
  as,
  variant = 'h2',
  className,
  children,
  ...rest
}: HeadingProps) {
  const Tag = (as ?? tagMap[variant ?? 'h2']) as React.ElementType
  return (
    <Tag className={cn(headingVariants({ variant }), className)} {...rest}>
      {children}
    </Tag>
  )
}
